import Loading from "components/Loading";
import axiosClient from "lib/axiosConfig";
import toastify from "lib/toastify";
import api from "operations/network/api";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { convertBytes } from "utils/convertor";
import { useMutationCustom } from "utils/useMutationCustom";
import DragAndDrop from "./DragAndDrop";
import styles from "./UploadTab.module.scss";

const UploadTab = ({ handleClickedImage, selectedPhoto, handleModal, FOLDER_SLUG }) => {
  //  ----------------------------------------- STATES/REFS/CONST ----------------------------------------- //

  const [userUploadedFile, setUserUploadedFile] = useState(null);
  const [imageDimensions, setImageDimensions] = useState({});
  const imageRef = useRef(null);
  const [folderOptions, setFolderOptions] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [folderError, setFolderError] = useState(true);
  const [previewImage, setPreviewImage] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [previewElement, setPreviewElement] = useState("");
  let fileUrl;
  const { t } = useTranslation();

  const sendingFile = async (params) => await axiosClient().post(api["files"].base, params);
  // const getFolders = async () => await axiosClient().get(api["folder"].list);

  //  ----------------------------------------- MUTATING ----------------------------------------- //
  const onSuccessMutating = () => {
    toastify.success({ title: "success" });
    URL.revokeObjectURL(fileUrl);
    resetFields();
  };
  const { isLoading, data, mutate } = useMutationCustom({
    url: sendingFile,
    invalidQuery: `galley_get`,
    onSuccess: onSuccessMutating,
  });
  //  ----------------------------------------- GETTING FOLDERS ----------------------------------------- //
  // const onSuccessGettingFolders = ({ data }) => {
  //   setFolderOptions(selectConvert(data?.result));
  // };
  // const foldersData = useQueryCustom({
  //   name: "foldersList",
  //   url: getFolders,
  //   onSuccess: onSuccessGettingFolders,
  //   params: { sort: "desc", page: 1, limit: 10, status: 1 },
  // });
  //  ----------------------------------------- HANDLERS ----------------------------------------- //
  const handleSelectFile = (e) => {
    if (e.target) {
      setUserUploadedFile(e.target.files[0]);
    } else {
      setUserUploadedFile(e);
    }
  };

  const handleUploadButton = () => {
    const formData = new FormData();
    formData.append("file", userUploadedFile);
    // formData.append("folder", selectedFolder?.value);
    // inputValue && formData.append("title", inputValue);
    mutate(formData);
  };

  const handleCancelButton = () => {
    resetFields();
  };

  const handleImageLoad = (e) => {
    if (imageRef.current.naturalWidth) {
      setImageDimensions({
        width: imageRef.current.naturalWidth,
        height: imageRef.current.naturalHeight,
      });
    }
  };

  const handleSelectingFolder = (e) => {
    setSelectedFolder(e);
    setFolderError(false);
  };

  const handleInputValue = (e) => {
    setInputValue(e.target.value);
  };
  //  ----------------------------------------- FUNCTIONS ----------------------------------------- //
  function selectConvert(data) {
    return data?.map((param) => ({ label: param?.name || param?.title, value: param._id, slug: param?.slug }));
  }

  function resetFields() {
    setUserUploadedFile(null);
    setSelectedFolder(null);
    setFolderError(true);
    setInputValue("");
  }

  //  ----------------------------------------- EFFECTS ----------------------------------------- //
  useEffect(() => {
    if (userUploadedFile) {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   // handleClickedImage(e.target.result);
      //   setPreviewImage(e.target.result);
      // };
      // reader.readAsDataURL(userUploadedFile);
      fileUrl = URL.createObjectURL(userUploadedFile);

      if (userUploadedFile?.type?.startsWith("image/")) {
        // For images
        setPreviewElement(<img src={fileUrl} alt="Preview" />);
      } else if (userUploadedFile?.type?.startsWith("video/")) {
        // For videos
        setPreviewElement(<video src={fileUrl} controls style={{ maxWidth: "300px" }} />);
      } else if (userUploadedFile?.type === "application/pdf") {
        // For PDFs
        setPreviewElement(<embed src={fileUrl} type="application/pdf" width="100%" height="600px" />);
      }
    }
  }, [userUploadedFile]);

  useEffect(() => {
    if (FOLDER_SLUG && folderOptions) {
      const foundFolder = folderOptions.find((item) => item.slug === FOLDER_SLUG);
      handleSelectingFolder(foundFolder);
    }
  }, [folderOptions, FOLDER_SLUG]);

  return (
    <div className={styles.uploadTab}>
      <div className={styles.titleWrapper}>
        <h3>{t("upload_your_file")}</h3>
      </div>
      {userUploadedFile ? (
        <div className={styles.flexWrapper}>
          <div className={styles.selectedPhotoWrapper}>
            {previewImage ? <img ref={imageRef} src={previewImage} alt="uploaded photo" onLoad={handleImageLoad} /> : ""}
            {previewElement ? previewElement : ""}
          </div>
          <div className={styles.controlWrapper}>
            <div className={styles.photoDetails}>
              <p>
                {t("name")}: {userUploadedFile?.name}
              </p>
              <p>
                {t("size")}:{" "}
                {imageDimensions.width || imageDimensions.height ? imageDimensions?.width + " × " + imageDimensions?.height : "Calculating..."} -{" "}
                {convertBytes(userUploadedFile?.size)}
              </p>
              <p>
                {t("type")}: {userUploadedFile?.type}
              </p>
            </div>
            <div className={styles.extraInformationWrapper}>
              <h3>{t("upload")} :</h3>
              {/* <Form.Group className={styles.formGroup}>
                <div className={"d-flex justify-content-between"}>
                  <label htmlFor={"name"}>Title :</label>
                </div>
                <Form.Control id={"name"} name={"name"} type="text" placeholder="Choose a new title" onChange={handleInputValue} />
              </Form.Group>
              <Form.Group className={"form-group "}>
                <div className={"d-flex justify-content-between"}>
                  <label htmlFor={"folder"}>Folder * :</label>
                  {folderError && <div className={`error-text`}>Choose please !</div>}
                </div>
                <Select className="custom-selector" placeholder={"Choose a folder"} options={folderOptions} value={selectedFolder} onChange={handleSelectingFolder} />
              </Form.Group> */}

              <div className={styles.buttonsWrapper}>
                <button className="btn btn-success btn-sm mr-2 btn btn-primary" disabled={isLoading} onClick={handleUploadButton}>
                  {isLoading ? <Loading size="sm" /> : t("upload")}
                </button>
                <button className="btn btn-danger btn-sm btn btn-primary" disabled={isLoading} onClick={handleCancelButton}>
                  {t("cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // <div className={styles.uploadHereWrapper}>
        <DragAndDrop {...{ handleSelectFile }}>
          <input type="file" name="file" id="file" accept=".jpg,.jpeg,.png,.pdf,.mp4" className={styles.fileInput} onChange={handleSelectFile} />
          <label htmlFor="file" className={styles.fileLabel}>
            {t("click_to_choose")}
          </label>
          <p>{t("or")}</p>
          <p className={styles.dragAndDrop}>{t("drag_drop")}</p>
          <p className={styles.accepted}>{t("accepted_file")}</p>
        </DragAndDrop>
        // </div>
      )}
    </div>
  );
};

export default UploadTab;
